// svelte-dnd-action renders the dragged <tr> as a clone OUTSIDE its table, so
// the clone loses everything the table gave it: column widths collapse to
// content, and DaisyUI's `.table :where(td)` descendant styles (padding, font
// size, vertical alignment) stop matching — the floating row looks like
// unstyled text stacked in a corner. This returns a `transformDraggedElement`
// hook that copies the in-table source row's measured layout onto the clone
// (the dragged item's placeholder row stays in the tbody at `index`, so its
// layout is still table-driven and correct to measure from).
export const transformDraggedRow = (getTbody) => (draggedEl, _data, index) => {
  const source = getTbody()?.querySelectorAll(':scope > tr')[index]
  if (!source) return

  const sourceStyle = getComputedStyle(source)
  draggedEl.style.display = 'table'
  draggedEl.style.tableLayout = 'fixed'
  draggedEl.style.width = `${source.offsetWidth}px`
  draggedEl.style.height = `${source.offsetHeight}px`
  draggedEl.style.font = sourceStyle.font
  draggedEl.style.color = sourceStyle.color
  draggedEl.classList.add('bg-base-100', 'shadow-lg', 'rounded-box')

  Array.from(draggedEl.children).forEach((cell, cellIndex) => {
    const sourceCell = source.children[cellIndex]
    if (!sourceCell) return

    const cellStyle = getComputedStyle(sourceCell)
    cell.style.display = 'table-cell'
    cell.style.width = `${sourceCell.offsetWidth}px`
    cell.style.maxWidth = `${sourceCell.offsetWidth}px`
    cell.style.boxSizing = 'border-box'
    cell.style.padding = cellStyle.padding
    cell.style.textAlign = cellStyle.textAlign
    cell.style.verticalAlign = cellStyle.verticalAlign
    cell.style.whiteSpace = cellStyle.whiteSpace
    cell.style.overflow = 'hidden'
  })
}
